import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const Container = styled.div`
  > span {
    cursor: pointer;
    color: ${Colors.Blue50};
  }
`
